// extracted by mini-css-extract-plugin
export default {"tooltip":"vQ-z","arrow":"wQ-z"};